import { render, staticRenderFns } from "./IconMicrophone.vue?vue&type=template&id=19404a1c"
import script from "./IconMicrophone.vue?vue&type=script&lang=js"
export * from "./IconMicrophone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports